import React from "react";
import PrintField from "../../shared/PrintField";
import "./Relocation.css";

// stable component type (capture / print mode comes from PrintModeContext)
const InputField = PrintField;

// ต้อง forwardRef เพื่อให้ wrapper แคปได้
const Relocation = React.forwardRef((props, ref) => {
  return (
    <div className="inv-page">
      {/* ให้ ref เกาะที่กระดาษ A4 */}
      <div className="inv-paper" ref={ref}>
        <div className="inv-header-right">
          <div className="inv-bold">
            บริษัท{" "}
            <InputField
              className="inv-line inv-line-long"
              style={{ width: "200px" }}
              spellCheck={false}
            />
          </div>

          <div className="inv-header-date inv-bold">
            วันที่{" "}
            <InputField
              className="inv-line inv-line-short"
              style={{ width: "50px" }}
              spellCheck={false}
            />{" "}
            เดือน{" "}
            <InputField
              className="inv-line inv-line-short"
              style={{ width: "60px" }}
              spellCheck={false}
            />{" "}
            ปี{" "}
            <InputField
              className="inv-line inv-line-short"
              style={{ width: "60px" }}
              spellCheck={false}
            />
          </div>
        </div>

        <div className="inv-body">
          <div className="inv-row">
            <span className="inv-bold">
              เรื่อง&nbsp;&nbsp;ขอเชิญประชุมวิสามัญผู้ถือหุ้น ครั้งที่
            </span>

            <span className="inv-inline">
              <InputField
                className="inv-line inv-line-date"
                style={{ width: "30px" }}
                spellCheck={false}
              />
              <span className="inv-sep">/</span>
              <InputField
                className="inv-line inv-line-date"
                style={{ width: "30px" }}
                spellCheck={false}
              />
            </span>
          </div>

          <div className="inv-row inv-row-learn inv-bold">
            เรียน&nbsp;&nbsp;ท่านผู้ถือหุ้นของบริษัท
          </div>

          <p className="inv-paragraph">
            ด้วยที่คณะกรรมการบริษัทมีมติให้เรียกประชุมวิสามัญผู้ถือหุ้น
            <br />
            ครั้งที่{" "}
            <InputField
              className="inv-line inv-line-tiny"
              style={{ width: "40px" }}
              spellCheck={false}
            />
            <span className="inv-sep">/</span>
            <InputField
              className="inv-line inv-line-tiny"
              style={{ width: "40px" }}
              spellCheck={false}
            />{" "}
            ในวันที่{" "}
            <InputField
              className="inv-line inv-line-date"
              style={{ width: "40px" }}
              spellCheck={false}
            />{" "}
            เดือน{" "}
            <InputField
              className="inv-line inv-line-date"
              style={{ width: "70px" }}
              spellCheck={false}
            />{" "}
            ปี{" "}
            <InputField
              className="inv-line inv-line-date"
              style={{ width: "60px" }}
              spellCheck={false}
            />{" "}
            เวลา{" "}
            <InputField
              className="inv-line inv-line-date"
              style={{ width: "50px" }}
              spellCheck={false}
            />{" "}
            น. ณ สำนักงานของบริษัท เลขที่{" "}
            <InputField
              className="inv-line inv-line-long"
              style={{ width: "140px" }}
              spellCheck={false}
            />{" "}
            เพื่อพิจารณาเรื่องต่างๆ ตามระเบียบวาระต่อไปนี้
          </p>

          <div className="inv-agenda">
            <div className="inv-agenda-item">
              วาระที่ 1 พิจารณาแก้ไขที่ตั้้งสำนักงานของบริษัท
              (ระบุที่ตั้งสำนักงานแห่งใหม่)
            </div>
            <div className="inv-agenda-item">
              วาระที่ 2 พิจารณาแก้ไขเพิ่มเติมหนังสือบริคณห์สนธิ ข้อ 2. ดังนี้
              <div className="inv-agenda-sub">
              "ข้อ 2. สำนักงานของบริษัทตั้งอยู่ ณ จังหวัด นนทบุรี"
              </div>
            </div>
            <div className="inv-agenda-item">
              วาระที่ 3 พิจารณาเรื่องอื่นๆ (ถ้ามี)
            </div>
          </div>

          <p className="inv-paragraph">
            ดังนั้น จึงขอเรียนเชิญท่านผู้ถือหุ้นไปประชุมตามวัน เวลา
            และสถานที่ดังกล่าวข้างต้นโดยพร้อมเพียงกันด้วย จักขอบคุณยิ่ง
          </p>

          <div className="inv-footer">
            <div className="inv-footer-text">ขอแสดงความนับถือ</div>

            <div className="inv-sign-block">
              <InputField className="inv-sign-line" spellCheck={false} optional />
              <div className="inv-sign-name">
                ( <InputField className="inv-sign-name-field" printFit optional={false} /> )
              </div>
              <div className="inv-sign-role">กรรมการ</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default Relocation;
